import { uniqWith, isEqual } from 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const fixAtomicBlockText = (block) => block.type === "atomic" ? __spreadProps(__spreadValues({}, block), { text: " " }) : block;
const addInlineStyleRanges = (block) => __spreadProps(__spreadValues({}, block), {
  inlineStyleRanges: block.inlineStyleRanges || []
});
const addLinkUnderlineRange = (block, range) => {
  const inlineStyleRange = {
    offset: range.offset,
    length: range.length,
    style: "UNDERLINE"
  };
  const inlineStyleRanges = uniqWith(
    [...block.inlineStyleRanges || [], inlineStyleRange],
    isEqual
  );
  return __spreadProps(__spreadValues({}, block), { inlineStyleRanges });
};
const isHexColor = (str) => /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(str);
const wrapTextColorStyle = (style) => isHexColor(style) ? JSON.stringify({ FG: style }) : style;
const fixTextColorStyle = (block) => {
  return __spreadProps(__spreadValues({}, block), {
    inlineStyleRanges: block.inlineStyleRanges.map((range) => __spreadProps(__spreadValues({}, range), {
      style: wrapTextColorStyle(range.style)
    }))
  });
};

export { addInlineStyleRanges, addLinkUnderlineRange, fixAtomicBlockText, fixTextColorStyle };
//# sourceMappingURL=block-processors.js.map
